import { render, staticRenderFns } from "./ClientCreditsAndLimitStepper.vue?vue&type=template&id=4159a516"
import script from "./ClientCreditsAndLimitStepper.vue?vue&type=script&lang=js"
export * from "./ClientCreditsAndLimitStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports